/**
 * BLoc sliders object
 */
var AccordionBlock = (function(){

    var that,


    init = function() {
        that = this
        $('.accordion-item__btn').each(function (index, el) {
            el.addEventListener('click', function () {
                handleClick(el)
            });

        });
        var active = $('.accordion-item__btn.is-active')
        if (active.length > 0) {
            adjustPanelHeight(active[0].nextElementSibling)
        }
    },
    adjustPanelHeight = function (panel) {
        if (panel.style.maxHeight){
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    },

    handleClick = function(el) {
        el.classList.toggle("is-active");
        adjustPanelHeight(el.nextElementSibling)
    };
    return { init: init }
})();
